import { AppPermissionsEnum } from '@/api/generator';
import {
  jobSeries,
  mainNavigationDashboard,
  mainNavigationMedicalSystems,
  quantitiesAndUnits,
  sectionJob,
  sectionLicenses,
  sectionSoftware,
  sectionTasks,
  sectionUserManagement,
  trends,
  mainNavigationQaEquipment,
  sectionReports,
} from '@/components/icons/icons';

import { qaEquipmentNavigationRaw } from '@/navigation/menus/qaEquipmentNavigationRaw';

import { medicalSystemsNavigationRaw } from '@/navigation/menus/medicalSystemsNavigationRaw';

import { quantitiesAndUnitsNavigationRaw } from '@/navigation/menus/dataTypesNavigationRaw';
import { resultManagementNavigationRaw } from '@/navigation/menus/resultManagementNavigationRaw';

import { protocolsNavigationRaw } from '@/navigation/menus/protocolsNavigationRaw';

import { userNavigationRaw } from '@/navigation/menus/userManagementNavigationRaw';

import { workManagementNavigationRaw } from '@/navigation/menus/workManagementNavigationRaw';

import { reportsNavigationRaw } from '@/navigation/menus/reportsNavigationRaw';
import { importedMeasurementsNavigationRaw } from '@/navigation/menus/importedMeasurementsNavigationRaw';
import { mdiDatabaseImport } from '@mdi/js';

import { licensesNavigationRaw } from '@/navigation/menus/licensesNavigationRaw';

import AccountAddView from '@/views/accounts/AccountAddView.vue';
import AccountDetailsView from '@/views/accounts/AccountDetailsView.vue';
import AccountEditView from '@/views/accounts/AccountEditView.vue';
import AccountOverviewView from '@/views/accounts/AccountOverviewView.vue';
import type { AccountDetailsViewProps, AccountEditViewProps } from '@/views/accounts/types';

import ActivationView from '@/views/ActivationView/ActivationView.vue';

import DashboardView from '@/views/DashboardView/DashboardView.vue';
import QaEquipmentAddConfigurationView from '@/views/qaEquipment/QaEquipmentAddConfigurationView.vue';
import QaEquipmentAddView from '@/views/qaEquipment/QaEquipmentAddView.vue';
import QaEquipmentDetailsView from '@/views/qaEquipment/QaEquipmentDetailsView.vue';
import QaEquipmentEditView from '@/views/qaEquipment/QaEquipmentEditView.vue';
import QaEquipmentOverviewView from '@/views/qaEquipment/QaEquipmentOverviewView.vue';

import EnumerationAddView from '@/views/enumerations/EnumerationAddView.vue';
import EnumerationDetailsView from '@/views/enumerations/EnumerationDetailsView.vue';
import EnumerationEditView from '@/views/enumerations/EnumerationEditView.vue';
import EnumerationOverviewView from '@/views/enumerations/EnumerationOverviewView.vue';
import TextAddView from '@/views/texts/TextAddView.vue';
import TextDetailsView from '@/views/texts/TextDetailsView.vue';
import TextEditView from '@/views/texts/TextEditView.vue';
import TextOverviewView from '@/views/texts/TextOverviewView.vue';

import ForgotPasswordView from '@/views/ForgotPasswordView/ForgotPasswordView.vue';
import { ForgotPasswordViewProps } from '@/views/ForgotPasswordView/types.ts';

import InstallationView from '@/views/InstallationView/InstallationView.vue';

import JobConfigurationAddView from '@/views/jobConfigurations/JobConfigurationAddView.vue';
import JobConfigurationDetailsView from '@/views/jobConfigurations/JobConfigurationDetailsView.vue';
import JobConfigurationEditView from '@/views/jobConfigurations/JobConfigurationEditView.vue';
import JobConfigurationOverviewView from '@/views/jobConfigurations/JobConfigurationOverviewView.vue';
import JobOccurrenceReportView from '@/views/jobOccurrences/JobOccurrenceReportView.vue';
import JobOccurrenceExecutionView from '@/views/jobOccurrences/JobOcurrenceExecutionView.vue';
import JobOccurrencesOverviewView from '@/views/jobOccurrences/JobOccurrenceOverviewView.vue';
import LicensesView from '@/views/LicensesView/LicensesView.vue';

import SettingsView from '@/views/SettingsView/SettingsView.vue';
import MedicalSystemAddView from '@/views/medicalSystems/MedicalSystemAddView.vue';
import MedicalSystemDetailsView from '@/views/medicalSystems/MedicalSystemDetailsView.vue';
import MedicalSystemEditView from '@/views/medicalSystems/MedicalSystemEditView.vue';
import MedicalSystemOverviewView from '@/views/medicalSystems/MedicalSystemOverviewView.vue';
import type { MedicalSystemAddViewProps } from '@/views/medicalSystems/types';

import NoPermissionsView from '@/views/NoPermissionsView/NoPermissionsView.vue';

import NotFoundView from '@/views/NotFoundView/NotFoundView.vue';

import PreferencesView from '@/views/PreferencesView/PreferencesView.vue';

import ProtocolAddView from '@/views/protocols/ProtocolAddView.vue';
import ProtocolDetailsView from '@/views/protocols/ProtocolDetailsView.vue';
import ProtocolEditView from '@/views/protocols/ProtocolEditView.vue';
import ProtocolOverviewView from '@/views/protocols/ProtocolOverviewView.vue';
import QuantityAddView from '@/views/quantities/QuantityAddView.vue';
import QuantityDetailsView from '@/views/quantities/QuantityDetailsView.vue';
import QuantityEditView from '@/views/quantities/QuantityEditView.vue';
import QuantityOverviewView from '@/views/quantities/QuantityOverviewView.vue';

import ResetPasswordView from '@/views/ResetPasswordView/ResetPasswordView.vue';

import RoleDetailsView from '@/views/roles/RoleDetailsView.vue';
import RoleOverviewView from '@/views/roles/RoleOverviewView.vue';
import type { RoleDetailsViewProps } from '@/views/roles/types';

import SignInView from '@/views/SignInView/SignInView.vue';
import TaskAddView from '@/views/tasks/TaskAddView.vue';
import TaskDetailsView from '@/views/tasks/TaskDetailsView.vue';
import TaskEditView from '@/views/tasks/TaskEditView.vue';
import TaskOverviewView from '@/views/tasks/TaskOverviewView.vue';

import TrendsDisplayView from '@/views/TrendsDisplayView/TrendsDisplayView.vue';
import TrendsSelectionView from '@/views/TrendsSelectionView/TrendsSelectionView.vue';

import UnitAddView from '@/views/units/UnitAddView.vue';
import UnitDetailsView from '@/views/units/UnitDetailsView.vue';
import UnitEditView from '@/views/units/UnitEditView.vue';
import UnitOverviewView from '@/views/units/UnitOverviewView.vue';

import { softwareSettingsNavigationRaw } from '@/navigation/menus/softwareSettingsNavigationRaw';
import EulaView from '@/views/EulaView/EulaView.vue';
import MaintenanceView from '@/views/MaintenanceView/MaintenanceView.vue';
import ReportsView from '@/views/ReportsView/ReportsView.vue';
import ImportedMeasurementDetailsView from '@/views/importedMeasurements/ImportedMeasurementDetailsView.vue';
import ImportedMeasurementOverviewView from '@/views/importedMeasurements/ImportedMeasurementOverviewView.vue';
import type { Router, RouterOptions } from 'vue-router';
import { routenames } from './routenames';
import { handleRedirect } from './utils';

import BackupView from '@/views/BackupView/BackupView.vue';
import DatabaseSettingsView from '@/views/DatabaseSettingsView/DatabaseSettingsView.vue';
import EmailSettingsView from '@/views/EmailSettingsView/EmailSettingsView.vue';
import InstallationNameView from '@/views/InstallationNameView/InstallationNameView.vue';
import SSLCertificateView from '@/views/SSLCertificateView/SSLCertificateView.vue';
import UpdateView from '@/views/UpdateView/UpdateView.vue';
import SignOutView from '@/views/SignOutView/SignOutView.vue';

export function createRoutes(router: Router): RouterOptions['routes'] {
  const redirect = handleRedirect(router);

  return [
    {
      path: '/',
      name: routenames.home,
      redirect: redirect([
        routenames.dashboard,
        routenames.resultManagement,
        routenames.workManagement,
        routenames.medicalSystems.root,
        routenames.qaEquipment.root,
        routenames.settings,
        routenames.signIn,
      ]),
    },
    {
      path: '/activation/:token/:email',
      name: routenames.activation,
      component: ActivationView,
      meta: {
        noAuthRequired: true,
        layout: 'SimpleLayout',
      },
      props: true,
    },
    {
      path: '/dashboard',
      name: routenames.dashboard,
      meta: {
        labelI18n: 'Dashboards',
        icon: mainNavigationDashboard,
        permissions: [AppPermissionsEnum.GlobalJobOccurrencesViewList],
      },
      component: DashboardView,
    },
    {
      path: '/qa-equipment',
      name: routenames.qaEquipment.root,
      meta: {
        subnavigation: qaEquipmentNavigationRaw,
        labelI18n: 'DosimetryAndQaEquipment',
      },
      redirect: redirect([routenames.qaEquipment.index]),
      children: [
        {
          path: 'entities',
          name: routenames.qaEquipment.index,
          meta: {
            icon: mainNavigationQaEquipment,
          },
          redirect: { name: routenames.qaEquipment.overview },
          children: [
            {
              path: '',
              name: routenames.qaEquipment.overview,
              component: QaEquipmentOverviewView,
              meta: {
                permissions: [AppPermissionsEnum.LocalDosimetryAndQaEquipmentViewList],
              },
            },
            {
              path: 'add',
              name: routenames.qaEquipment.add.configuration,
              component: QaEquipmentAddConfigurationView,
              props: true,
              meta: {
                permissions: [AppPermissionsEnum.LocalDosimetryAndQaEquipmentAdd],
              },
            },
            {
              path: 'add/from-catalog/:template',
              name: routenames.qaEquipment.add.fromCatalog,
              component: QaEquipmentAddView,
              props: true,
              meta: {
                permissions: [AppPermissionsEnum.LocalDosimetryAndQaEquipmentAdd],
              },
            },
            {
              path: 'add/other-manufacturer/:subCategory',
              name: routenames.qaEquipment.add.otherManufacturer,
              component: QaEquipmentAddView,
              props: true,
              meta: {
                permissions: [AppPermissionsEnum.LocalDosimetryAndQaEquipmentAdd],
              },
            },
            {
              path: ':id/edit',
              name: routenames.qaEquipment.edit,
              component: QaEquipmentEditView,
              props: true,
              meta: {
                permissions: [AppPermissionsEnum.LocalDosimetryAndQaEquipmentEdit],
              },
            },
            {
              path: ':id/details',
              name: routenames.qaEquipment.details,
              component: QaEquipmentDetailsView,
              props: true,
              meta: {
                permissions: [AppPermissionsEnum.LocalDosimetryAndQaEquipmentViewDetail],
              },
            },
          ],
        },
      ],
    },
    {
      path: '/forgot-password',
      name: routenames.forgotPassword,
      component: ForgotPasswordView,
      meta: {
        noAuthRequired: true,
        layout: 'SimpleLayout',
      },
      props: (route): ForgotPasswordViewProps => ({
        error: route.query.error ? String(route.query.error) : undefined,
        email: route.query.email ? String(route.query.email) : undefined,
      }),
    },
    {
      path: '/installation',
      component: InstallationView,
      meta: {
        noAuthRequired: true,
      },
      name: routenames.installation,
    },
    {
      path: '/sign-in',
      name: routenames.signIn,
      component: SignInView,
      meta: {
        noAuthRequired: true,
        layout: 'SimpleLayout',
      },
    },
    {
      path: '/sign-out',
      name: routenames.signOut,
      component: SignOutView,
      meta: {
        noAuthRequired: true,
        layout: 'EmptyLayout',
      },
    },
    {
      path: '/settings',
      redirect: { name: routenames.settings },
      meta: {
        labelI18n: 'PlatformManagement',
        permissionsMode: 'CHILDREN_ONE',
      },
      children: [
        {
          path: '',
          name: routenames.settings,
          component: SettingsView,
        },
        {
          path: 'licenses',
          name: routenames.licenses,
          component: LicensesView,
          meta: {
            icon: sectionLicenses,
            permissions: [AppPermissionsEnum.GlobalLicensesViewDetail],
            permissionsMode: 'CURRENT_ALL',
            subnavigation: licensesNavigationRaw,
          },
        },
        {
          path: 'data-types',
          name: routenames.dataTypes,
          redirect: redirect([routenames.quantities.index, routenames.units.index]),
          meta: {
            subnavigation: quantitiesAndUnitsNavigationRaw,
            icon: quantitiesAndUnits,
            permissionsMode: 'CURRENT_ALL',
          },
          children: [
            {
              path: 'quantities',
              name: routenames.quantities.index,
              redirect: redirect([routenames.quantities.overview]),
              children: [
                {
                  path: '',
                  name: routenames.quantities.overview,
                  component: QuantityOverviewView,
                  meta: {
                    permissions: [AppPermissionsEnum.GlobalQuantitiesViewList],
                  },
                },
                {
                  path: 'add',
                  name: routenames.quantities.add,
                  component: QuantityAddView,
                  meta: {
                    permissions: [AppPermissionsEnum.GlobalQuantitiesAdd],
                  },
                },
                {
                  path: ':id/edit',
                  name: routenames.quantities.edit,
                  component: QuantityEditView,
                  props: true,
                  meta: {
                    permissions: [AppPermissionsEnum.GlobalQuantitiesEdit],
                  },
                },
                {
                  path: ':id/details',
                  name: routenames.quantities.details,
                  component: QuantityDetailsView,
                  props: true,
                  meta: {
                    permissions: [AppPermissionsEnum.GlobalQuantitiesViewDetail],
                  },
                },
              ],
            },
            {
              path: 'enumerations',
              name: routenames.enumerations.index,
              redirect: redirect([routenames.enumerations.overview]),
              children: [
                {
                  path: '',
                  name: routenames.enumerations.overview,
                  component: EnumerationOverviewView,
                  meta: {
                    permissions: [AppPermissionsEnum.GlobalEnumerationsViewList],
                  },
                },
                {
                  path: 'add',
                  name: routenames.enumerations.add,
                  component: EnumerationAddView,
                  meta: {
                    permissions: [AppPermissionsEnum.GlobalEnumerationsAdd],
                  },
                },
                {
                  path: ':id/edit',
                  name: routenames.enumerations.edit,
                  component: EnumerationEditView,
                  props: true,
                  meta: {
                    permissions: [AppPermissionsEnum.GlobalEnumerationsEdit],
                  },
                },
                {
                  path: ':id/details',
                  name: routenames.enumerations.details,
                  component: EnumerationDetailsView,
                  props: true,
                  meta: {
                    permissions: [AppPermissionsEnum.GlobalEnumerationsViewDetail],
                  },
                },
              ],
            },
            {
              path: 'texts',
              name: routenames.texts.index,
              redirect: redirect([routenames.texts.overview]),
              children: [
                {
                  path: '',
                  name: routenames.texts.overview,
                  component: TextOverviewView,
                  meta: {
                    permissions: [AppPermissionsEnum.GlobalTextsViewList],
                  },
                },
                {
                  path: 'add',
                  name: routenames.texts.add,
                  component: TextAddView,
                  meta: {
                    permissions: [AppPermissionsEnum.GlobalTextsAdd],
                  },
                },
                {
                  path: ':id/edit',
                  name: routenames.texts.edit,
                  component: TextEditView,
                  props: true,
                  meta: {
                    permissions: [AppPermissionsEnum.GlobalTextsEdit],
                  },
                },
                {
                  path: ':id/details',
                  name: routenames.texts.details,
                  component: TextDetailsView,
                  props: true,
                  meta: {
                    permissions: [AppPermissionsEnum.GlobalTextsViewDetail],
                  },
                },
              ],
            },
            {
              path: 'units',
              name: routenames.units.index,
              redirect: redirect([routenames.units.overview]),
              children: [
                {
                  path: '',
                  name: routenames.units.overview,
                  component: UnitOverviewView,
                  meta: {
                    permissions: [AppPermissionsEnum.GlobalUnitsViewList],
                  },
                },
                {
                  path: 'add',
                  name: routenames.units.add,
                  component: UnitAddView,
                  meta: {
                    permissions: [AppPermissionsEnum.GlobalUnitsAdd],
                  },
                },
                {
                  path: ':id/edit',
                  name: routenames.units.edit,
                  component: UnitEditView,
                  props: true,
                  meta: {
                    permissions: [AppPermissionsEnum.GlobalUnitsEdit],
                  },
                },
                {
                  path: ':id/details',
                  name: routenames.units.details,
                  component: UnitDetailsView,
                  props: true,
                  meta: {
                    permissions: [AppPermissionsEnum.GlobalUnitsViewDetail],
                  },
                },
              ],
            },
          ],
        },
        {
          path: 'software',
          name: routenames.software,
          redirect: redirect([
            routenames.update,
            routenames.maintenance,
            routenames.sslCertificate,
            routenames.installationName,
            routenames.emailSettings,
            routenames.databaseSettings,
            routenames.backup,
          ]),
          meta: {
            icon: sectionSoftware,
            subnavigation: softwareSettingsNavigationRaw,
            permissionsMode: 'CURRENT_ALL',
          },
          children: [
            {
              path: 'update',
              name: routenames.update,
              component: UpdateView,
              meta: {
                permissions: [AppPermissionsEnum.GlobalSystemSettingsUpdate],
              },
            },
            {
              path: 'maintenance',
              name: routenames.maintenance,
              component: MaintenanceView,
              meta: {
                permissions: [AppPermissionsEnum.GlobalSystemSettingsAdvancedSettings],
              },
            },
            {
              path: 'TLSCertificate',
              name: routenames.sslCertificate,
              component: SSLCertificateView,
              meta: {
                permissions: [AppPermissionsEnum.GlobalSystemSettingsAdvancedSettings],
              },
            },
            {
              path: 'sslCertificate',
              redirect: { name: routenames.sslCertificate },
            },
            {
              path: 'installation-name',
              name: routenames.installationName,
              component: InstallationNameView,
              meta: {
                permissions: [AppPermissionsEnum.GlobalSystemSettingsAdvancedSettings],
              },
            },
            {
              path: 'email-settings',
              name: routenames.emailSettings,
              component: EmailSettingsView,
              meta: {
                permissions: [AppPermissionsEnum.GlobalSystemSettingsAdvancedSettings],
              },
            },
            {
              path: 'database-settings',
              name: routenames.databaseSettings,
              component: DatabaseSettingsView,
              meta: {
                permissions: [AppPermissionsEnum.GlobalSystemSettingsAdvancedSettings],
              },
            },
            {
              path: 'backup',
              name: routenames.backup,
              component: BackupView,
              meta: {
                permissions: [AppPermissionsEnum.GlobalSystemSettingsAdvancedSettings],
              },
            },
          ],
        },
        {
          path: 'protocols',
          name: routenames.protocols.index,
          meta: {
            subnavigation: protocolsNavigationRaw,
            icon: sectionTasks,
            permissionsMode: 'CURRENT_ALL',
          },
          redirect: redirect([routenames.protocols.overview]),
          children: [
            {
              path: '',
              name: routenames.protocols.overview,
              component: ProtocolOverviewView,
              meta: {
                permissions: [AppPermissionsEnum.GlobalProtocolsViewList],
              },
            },
            {
              path: 'add',
              name: routenames.protocols.add,
              component: ProtocolAddView,
              meta: {
                permissions: [AppPermissionsEnum.GlobalProtocolsAdd],
              },
            },
            {
              path: ':id/edit',
              props: true,
              name: routenames.protocols.edit,
              component: ProtocolEditView,
              meta: {
                permissions: [AppPermissionsEnum.GlobalProtocolsEdit],
              },
            },
            {
              path: ':id/details',
              props: true,
              name: routenames.protocols.details,
              component: ProtocolDetailsView,
              meta: {
                permissions: [AppPermissionsEnum.GlobalProtocolsViewDetail],
              },
            },
          ],
        },
        {
          path: 'user-management',
          name: routenames.userManagement,
          redirect: redirect([routenames.accounts.index, routenames.roles.index]),
          meta: {
            subnavigation: userNavigationRaw,
            icon: sectionUserManagement,
            permissionsMode: 'CURRENT_ALL',
          },
          children: [
            {
              path: 'accounts',
              name: routenames.accounts.index,
              redirect: { name: routenames.accounts.overview },
              children: [
                {
                  path: '',
                  name: routenames.accounts.overview,
                  component: AccountOverviewView,
                  meta: {
                    permissions: [AppPermissionsEnum.GlobalAccountsViewList],
                  },
                },
                {
                  path: 'add',
                  name: routenames.accounts.add,
                  component: AccountAddView,
                  meta: {
                    permissions: [AppPermissionsEnum.GlobalAccountsAdd],
                  },
                },
                {
                  path: ':id/edit',
                  name: routenames.accounts.edit,
                  component: AccountEditView,
                  meta: {
                    permissions: [AppPermissionsEnum.GlobalAccountsEdit],
                  },
                  props: (route): AccountEditViewProps => {
                    return {
                      id: parseInt(String(route.params.id), 10),
                    };
                  },
                },
                {
                  path: ':id/details',
                  name: routenames.accounts.details,
                  component: AccountDetailsView,
                  meta: {
                    permissions: [AppPermissionsEnum.GlobalAccountsViewDetail],
                  },
                  props: (route): AccountDetailsViewProps => {
                    return {
                      id: parseInt(String(route.params.id), 10),
                    };
                  },
                },
              ],
            },
            {
              path: 'roles',
              name: routenames.roles.index,
              redirect: { name: routenames.roles.overview },
              children: [
                {
                  path: '',
                  name: routenames.roles.overview,
                  component: RoleOverviewView,
                  meta: {
                    permissions: [AppPermissionsEnum.GlobalRolesViewList],
                  },
                },
                {
                  path: ':id/details',
                  name: routenames.roles.details,
                  component: RoleDetailsView,
                  meta: {
                    permissions: [AppPermissionsEnum.GlobalRolesViewDetail],
                  },
                  props: (route): RoleDetailsViewProps => {
                    return {
                      id: parseInt(String(route.params.id), 10),
                    };
                  },
                },
              ],
            },
          ],
        },
        {
          path: 'reports',
          name: routenames.reports,
          component: ReportsView,
          meta: {
            icon: sectionReports,
            subnavigation: reportsNavigationRaw,
            permissions: [AppPermissionsEnum.LocalResultManagementReportManagement],
            permissionsMode: 'CURRENT_ALL',
          },
        },
        {
          path: 'imported-measurements',
          name: routenames.importedMeasurements.index,
          redirect: redirect([routenames.importedMeasurements.overview]),
          meta: {
            icon: mdiDatabaseImport,
            subnavigation: importedMeasurementsNavigationRaw,
          },
          children: [
            {
              path: '',
              name: routenames.importedMeasurements.overview,
              component: ImportedMeasurementOverviewView,
            },
            {
              path: ':id/details',
              name: routenames.importedMeasurements.details,
              component: ImportedMeasurementDetailsView,
              props: true,
            },
          ],
        },
      ],
    },
    {
      path: '/medical-systems',
      name: routenames.medicalSystems.root,
      redirect: redirect([routenames.tasks.index]),
      meta: {
        subnavigation: medicalSystemsNavigationRaw,
        labelI18n: 'MedicalSystems',
      },
      children: [
        {
          path: 'entities',
          name: routenames.medicalSystems.index,
          meta: {
            icon: mainNavigationMedicalSystems,
          },
          redirect: { name: routenames.medicalSystems.overview },
          children: [
            {
              path: '',
              name: routenames.medicalSystems.overview,
              component: MedicalSystemOverviewView,
              meta: {
                permissions: [AppPermissionsEnum.LocalMedicalSystemsViewList],
              },
            },
            {
              path: 'add',
              name: routenames.medicalSystems.add,
              component: MedicalSystemAddView,
              props: (route): MedicalSystemAddViewProps => {
                return {
                  options: route.query,
                };
              },
              meta: {
                permissions: [AppPermissionsEnum.LocalMedicalSystemsAdd],
              },
            },
            {
              path: ':id/edit',
              name: routenames.medicalSystems.edit,
              component: MedicalSystemEditView,
              props: true,
              meta: {
                permissions: [AppPermissionsEnum.LocalMedicalSystemsEdit],
              },
            },
            {
              path: ':id/details',
              name: routenames.medicalSystems.details,
              component: MedicalSystemDetailsView,
              props: true,
              meta: {
                permissions: [AppPermissionsEnum.LocalMedicalSystemsViewDetail],
              },
            },
          ],
        },
        {
          path: 'tasks',
          name: routenames.tasks.index,
          meta: {
            icon: sectionTasks,
          },
          redirect: { name: routenames.tasks.overview },
          children: [
            {
              path: '',
              name: routenames.tasks.overview,
              component: TaskOverviewView,
              meta: {
                permissions: [AppPermissionsEnum.GlobalTaskManagementViewList],
              },
            },
            {
              path: 'add/:category/:subCategory/:taskType',
              name: routenames.tasks.add,
              component: TaskAddView,
              props: true,
              meta: {
                permissions: [AppPermissionsEnum.GlobalTaskManagementAdd],
              },
            },
            {
              path: ':id/edit',
              name: routenames.tasks.edit,
              component: TaskEditView,
              props: true,
              meta: {
                permissions: [AppPermissionsEnum.GlobalTaskManagementEdit],
              },
            },
            {
              path: ':id/details',
              name: routenames.tasks.details,
              component: TaskDetailsView,
              props: true,
              meta: {
                permissions: [AppPermissionsEnum.GlobalTaskManagementViewDetail],
              },
            },
          ],
        },
      ],
    },
    {
      path: '/no-permissions',
      name: routenames.noPermissions,
      component: NoPermissionsView,
    },
    {
      path: '/preferences',
      name: routenames.preferences,
      component: PreferencesView,
      meta: {
        labelI18n: 'Preferences',
      },
    },
    {
      path: '/reset-password/:token/:email',
      name: routenames.resetPassword,
      component: ResetPasswordView,
      meta: {
        noAuthRequired: true,
        layout: 'SimpleLayout',
      },
      props: true,
    },
    {
      path: '/work-management',
      name: routenames.workManagement,
      redirect: redirect([routenames.jobOccurrences.index, routenames.jobConfigurations.index]),
      meta: {
        labelI18n: 'WorkManagement',
        subnavigation: workManagementNavigationRaw,
        permissions: [AppPermissionsEnum.GlobalJobOccurrencesViewList],
      },
      children: [
        {
          path: 'jobs',
          name: routenames.jobOccurrences.index,
          redirect: { name: routenames.jobOccurrences.overview },
          meta: {
            icon: jobSeries,
          },
          children: [
            {
              path: '',
              name: routenames.jobOccurrences.overview,
              component: JobOccurrencesOverviewView,
              meta: {
                permissions: [AppPermissionsEnum.GlobalJobOccurrencesViewList],
              },
            },
            {
              path: ':id/report',
              name: routenames.jobOccurrences.report,
              component: JobOccurrenceReportView,
              meta: {
                permissions: [AppPermissionsEnum.GlobalJobOccurrencesViewDetail],
                layout: 'PrintLayout',
              },
            },
            {
              path: ':id/:action?',
              name: routenames.jobOccurrences.execution,
              component: JobOccurrenceExecutionView,
              props: true,
              meta: {
                permissions: [AppPermissionsEnum.GlobalJobOccurrencesViewDetail],
              },
            },
          ],
        },
        {
          path: 'job-configurations',
          name: routenames.jobConfigurations.index,
          redirect: { name: routenames.jobConfigurations.overview },
          meta: {
            icon: sectionJob,
          },
          children: [
            {
              path: '',
              name: routenames.jobConfigurations.overview,
              component: JobConfigurationOverviewView,
              meta: {
                permissions: [AppPermissionsEnum.GlobalJobConfigurationsViewList],
              },
            },
            {
              path: 'add',
              name: routenames.jobConfigurations.add,
              component: JobConfigurationAddView,
              meta: {
                permissions: [AppPermissionsEnum.GlobalJobConfigurationsAdd],
              },
            },
            {
              path: 'copy/:copyId',
              name: routenames.jobConfigurations.copy,
              component: JobConfigurationAddView,
              props: true,
              meta: {
                permissions: [AppPermissionsEnum.GlobalJobConfigurationsAdd],
              },
            },
            {
              path: ':id/edit',
              name: routenames.jobConfigurations.edit,
              component: JobConfigurationEditView,
              props: true,
              meta: {
                permissions: [AppPermissionsEnum.GlobalJobConfigurationsEdit],
              },
            },
            {
              path: ':id/details',
              name: routenames.jobConfigurations.details,
              component: JobConfigurationDetailsView,
              props: true,
              meta: {
                permissions: [AppPermissionsEnum.GlobalJobConfigurationsViewDetail],
              },
            },
          ],
        },
      ],
    },
    {
      path: '/result-management',
      name: routenames.resultManagement,
      redirect: redirect([routenames.trends]),
      meta: {
        labelI18n: 'ResultsManagement',
        subnavigation: resultManagementNavigationRaw,
      },
      children: [
        {
          path: 'trends',
          name: routenames.trends,
          redirect: redirect([routenames.trendSelection]),
          meta: {
            icon: trends,
          },
          children: [
            {
              path: '',
              name: routenames.trendSelection,
              component: TrendsSelectionView,
              meta: {
                permissions: [AppPermissionsEnum.LocalResultManagementViewDatasets],
              },
            },
            {
              path: 'display',
              name: routenames.trendDisplay,
              component: TrendsDisplayView,
              meta: {
                permissions: [AppPermissionsEnum.LocalResultManagementViewDetail],
              },
            },
          ],
        },
      ],
    },
    {
      path: '/eula',
      name: routenames.eula,
      component: EulaView,
      meta: {
        icon: sectionReports,
        noAuthRequired: true,
      },
    },
    {
      path: '/not-found',
      name: routenames.notFound,
      component: NotFoundView,
      meta: {
        noAuthRequired: true,
        layout: (isAuthenticated) => (isAuthenticated ? 'BaseLayout' : 'SimpleLayout'),
      },
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: { name: routenames.notFound },
    },
  ];
}
